import { render, staticRenderFns } from "./ChurchNavbar.vue?vue&type=template&id=2822182c&"
import script from "./ChurchNavbar.vue?vue&type=script&lang=js&"
export * from "./ChurchNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports